import { useTranslation } from "next-i18next";
import Form from "@common/components/form";
import { ChangeEvent } from "react";
import {
  FilterAction,
  FilterActions,
  FilterKeys,
  SortByFilter,
  VehicleFilter,
  VehicleSortBy,
} from "../types/vehicleFilter";
import FilterDisclosure from "./FilterDisclosure";

type Props = {
  onUpdate(filterAction: FilterAction): void;
  sortByData: VehicleSortBy[];
  vehicleFilters: VehicleFilter[];
};
const VehicleSortFilter = ({ onUpdate, sortByData, vehicleFilters }: Props) => {
  const { t } = useTranslation(["vehiclesFilters"]);

  const defaultSort = sortByData[0];

  const sortByFilter = vehicleFilters.find(
    (f) => f.key === FilterKeys.SortBy
  ) as SortByFilter;

  const selectedSort = sortByFilter;

  const handleCheckChange = (
    displaySortBy: VehicleSortBy,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (selectedSort) {
      onUpdate({
        type: FilterActions.RemoveByIdAndType,
        payload: {
          type: FilterKeys.SortBy,
          id: selectedSort.state.id,
        },
      });
    }

    if (displaySortBy === defaultSort && selectedSort) {
      onUpdate({
        type: FilterActions.RemoveByIdAndType,
        payload: {
          type: FilterKeys.SortBy,
          id: selectedSort.state.id,
        },
      });
    }

    if (event && event.target.checked && displaySortBy) {
      onUpdate({
        type: FilterActions.AddSortByFilter,
        payload: {
          id: displaySortBy.id.toString(),
          name: displaySortBy.name,
        },
      });
    }
  };

  return (
    <FilterDisclosure
      headerText={t("vehiclesFilters:sort_by")}
      sideHeaderText={t(
        selectedSort?.state?.name ? selectedSort.state.name : defaultSort.name
      )}
    >
      <div className="body-3 flex flex-col">
        {sortByData &&
          sortByData.map((tt) => (
            <Form.Radio
              key={tt.id}
              id={`radio-${tt.id}`}
              label={t(tt.name)}
              name="radio"
              onChange={(event) => handleCheckChange(tt, event)}
              checked={
                selectedSort?.state.id === tt.id.toString() ||
                (!selectedSort && tt.id === defaultSort.id)
              }
            />
          ))}
      </div>
    </FilterDisclosure>
  );
};
export default VehicleSortFilter;
